import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { GetDailyPhysicalActivity } from '../../core/my-journal.selector';
import {
  DeleteMyJOurnalRecordsRequest,
  FetchPhysicalDailyActivityRequest,
} from '../../core/my-journal.actions';
import { AddDailyPhysicalActivityComponent } from '../add-daily-physical-activity/add-daily-physical-activity.component';

@Component({
  selector: 'app-daily-physical-activity-tracker',
  templateUrl: './daily-physical-activity-tracker.component.html',
  styleUrls: ['./daily-physical-activity-tracker.component.css'],
})
export class DailyPhysicalActivityTrackerComponent {
  expandPanel: any = true;
  dataSource = [];
  loading: boolean = false;
  @Input() selectedDate;
  @Input() memberId;
  @Input() groupId;

  colDef = ['dayTime', 'activity', 'intensity', 'mins', 'points', 'comments', 'actions'];
  totalPa;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store,
  ) {}

  ngOnInit() {
    this.store.dispatch(FetchPhysicalDailyActivityRequest());
    this.store
      .select(GetDailyPhysicalActivity)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((physicalActivity) => {
        this.dataSource = physicalActivity.list;
        this.totalPa = physicalActivity.totalPa;
        this.loading = physicalActivity.loading;
      });
  }

  addPhysicalActivity() {
    const physicalActivity = this.commonService.openDialog({
      data: {
        component: AddDailyPhysicalActivityComponent,
        data: {
          memberId: this.memberId,
          selectedDate: this.selectedDate,
          groupId: this.groupId,
        },
      },
    });
  }

  onEditClicked(data: any) {
    const addFood = this.commonService.openDialog({
      data: {
        component: AddDailyPhysicalActivityComponent,
        data: {
          memberId: this.memberId,
          selectedDate: this.selectedDate,
          groupId: this.groupId,
        },
        previousData: data,
      },
    });
  }

  onDeleteRecord(data) {
    this.store.dispatch(
      DeleteMyJOurnalRecordsRequest({
        payload: {
          ...(this.memberId ? { memberId: this.memberId } : {}),
          selectedDate: this.selectedDate,
          recordId: data.id,
          recordType: 2,
        },
      }),
    );
  }

  onDeleteClicked(data: any) {
    this.store.dispatch(
      DeleteMyJOurnalRecordsRequest({
        payload: {
          ...(this.memberId ? { memberId: this.memberId } : {}),
          selectedDate: this.selectedDate,
          recordId: data.id,
          recordType: 2, // Physical activity type is 2
        },
      }),
    );
  }

  getIntensityIcon(value: string): string | null {
    // Return SVG icon name for intensity values
    if (value === '100') {
      return '100 (1)-20250401-134935';
    } else if (value === '200') {
      return '200 (1)-20250401-135016';
    } else if (value === '300') {
      return '300-20250401-135033';
    } else if (value === '400') {
      return '400-20250401-135052';
    }
    return null;
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
